import React, { useState } from 'react';
import CancelSubscriptionModal from 'components/cancel_subscription_modal/cancel_subscription_modal';

interface Props {
  customerPortalUrl?: string;
  cancelSubscriptionUrl?: string;
  pendingCancellation?: boolean;
  linkClassName?: string;
  textClassName?: string;
  cancelLinkStyle?: React.CSSProperties;
  planPeriodDays?: number;
  inTrial?: boolean;
  subscriptionPlan?: {
    in_trial?: boolean;
    subscription_product?: {
      with_duration_contract?: boolean;
    };
    end_date?: string;
  };
  cancellationReasons?: Array<{ value: string; label: string }>;
}

export default function SubscriptionManagementLinks(props: Props) {
  const {
    customerPortalUrl,
    cancelSubscriptionUrl,
    pendingCancellation,
    linkClassName,
    textClassName,
    cancelLinkStyle = { color: '#f51f00' },
    inTrial,
    subscriptionPlan
  } = props;

  const [showCancelModal, setShowCancelModal] = useState(false);

  const handleCancelClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    setShowCancelModal(true);
  };

  const handleModalClose = () => {
    setShowCancelModal(false);
  };

  if (pendingCancellation) {
    const cancelMessage = inTrial
      ? 'Your trial has been cancelled.'
      : props.planPeriodDays && props.planPeriodDays > 30
        ? 'Your subscription is scheduled to be cancelled at the end of the current contract period.'
        : 'Your subscription is scheduled to be cancelled at the end of the current billing period.';
    return (
      <p className={textClassName}>
        {cancelMessage}
      </p>
    );
  }

  return (
    <>
      {customerPortalUrl && (
        <p className={textClassName}>
          Need to update your payment method ?&nbsp;
          <a
            href={customerPortalUrl}
            className={linkClassName}
            rel='noreferrer'
          >
            Manage payment methods
          </a>
          .
        </p>
      )}
      {cancelSubscriptionUrl && (
        <>
          <p className={textClassName}>
            Need to cancel your subscription?&nbsp;
            <a
              href={cancelSubscriptionUrl}
              className={linkClassName}
              style={cancelLinkStyle}
              onClick={handleCancelClick}
            >
              Cancel here
            </a>
            . {inTrial
              ? 'Your trial will be cancelled immediately.'
              : props.planPeriodDays && props.planPeriodDays > 30
                ? 'Your subscription will remain active until the end of your current contract period.'
                : 'Your subscription will remain active until the end of your current billing period.'}
          </p>
          <CancelSubscriptionModal
            onClose={handleModalClose}
            cancelSubscriptionUrl={cancelSubscriptionUrl}
            subscriptionPlan={subscriptionPlan}
            isOpen={showCancelModal}
            cancellationReasons={props.cancellationReasons}
          />
        </>
      )}
    </>
  );
}